import { mobileAccess } from "#skyward_global";
import { registerEvents } from "./skyward.ui.events";
import { alignTitles } from "./skyward.ui.fieldWrapper";
import LabeledDataListConstructor from "./vue/labeledDataList";

const events =
{
    init
};

registerEvents("labeledDataList", events);

function init(this: HTMLElement)
{
    const container = $(this);
    const props = $.extend({}, container.data());
    delete props.loadAction;

    LabeledDataListConstructor.buildVue({
        container: container[0],
        isMobile: mobileAccess,
        props: props
    });

    alignTitles(container);
}
